// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: false,
    backendEndpoint: 'https://api.dev.global-interview-toolkit.siemens.cloud',
    newTracking: {
        endpointStage: 'prod',
        apiKey: 'u80Yy5hSy39VpTvM1joi76T9d5u7ma9AaP8rBGP9'
    },
    msalConfig: {
        auth: {
            clientId: 'aab09a4f-136e-4491-8ccc-5d4f8a4e2c79',
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        {
            scopes: ['openid', 'profile', 'email', 'offline_access'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.dev.global-interview-toolkit.siemens.cloud/Api.ReadWrite'],
            uri: 'https://api.dev.global-interview-toolkit.siemens.cloud/*'
        },
        {
            scopes: ['https://api.ingestion.tracking.suites.siemens.cloud/.default'],
            uri: 'https://api.ingestion.tracking.suites.siemens.cloud/v3/ingest-record'
        }
    ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
